import { formatPattern } from "react-router-utils";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import RaisedText from "app/components/UI/RaisedText";
import React from "react";
import ValidClubList from "../ValidClubList";
import b64toBlob from "../../../helpers/b64toBlob";
import classes from "./ProductDetail.module.css";
import logo from "../../Header/logo.png";

export const ProductDetail = ({
  translate,
  intl,
  clubId,
  translatePeriod,
  product,
  productBehavior,
  onAddToCart,
  offer,
  isPrepareCart,
  translateDate
}) => {
  const imgPath = product.getIn(["publicMetadata", "imagePath"]);
  const blob = imgPath && b64toBlob(imgPath.get("content"), imgPath.get("type"));
  const blobUrl = blob && URL.createObjectURL(blob);

  return (
    <div className={classes.productDetailContainer}>
      <div className={classes.productDetail__header}>
        <div className={classes.productDetail__title}>{product.getIn(["publicMetadata", "title"])}</div>
        <div className={classes.productDetail__subtitle}>{product.getIn(["publicMetadata", "subTitle"])}</div>
      </div>

      {imgPath ? (
        <Flex
          className={classes.productDetail__media}
          direction="row"
          start
          style={{
            backgroundImage: `url("${blobUrl}")`
          }}
        />
      ) : (
        <Flex className={classes.productDetail__media} style={{ background: "#FAFAFA" }} direction="row" start>
          <img className={classes.productDetail__picture__noImage} src={logo} alt="logo BlueGreen" />
        </Flex>
      )}

      <div className={classes.productDetail__price}>
        {intl.formatNumber(offer.get("totalPriceTI") / 100, {
          style: "currency",
          currency: "EUR"
        })}
      </div>

      <RaisedText.Collapsible
        className={classes.productDetail__description}
        label={translate("Description")}
        isTransform
      >
        {product.getIn(["publicMetadata", "description"])}
      </RaisedText.Collapsible>

      <div className={classes.productDetail__btn}>
        <Button
          primary
          disabled={isPrepareCart}
          label={translate("Ajouter au panier")}
          fullWidth
          onClick={onAddToCart}
        />
      </div>

      {productBehavior && (
        <div className={classes.productDetail__more}>
          {productBehavior.getIn(["configuration", "validityPeriod"]) && (
            <RaisedText label={translate("Durée de validité")}>
              {translatePeriod(productBehavior.getIn(["configuration", "validityPeriod"]))}
            </RaisedText>
          )}
          {productBehavior.getIn(["configuration", "usagePeriod"]) && (
            <RaisedText.Collapsible label={translate("Période d'utilisation")}>
              du {translateDate(productBehavior.getIn(["configuration", "usagePeriod", "startDate"]))} au{" "}
              {translateDate(productBehavior.getIn(["configuration", "usagePeriod", "endDate"]))}
            </RaisedText.Collapsible>
          )}
          <RaisedText.Collapsible label={translate("Golfs valides")}>
            <ValidClubList productBehavior={productBehavior} />
          </RaisedText.Collapsible>
        </div>
      )}

      <Link className={classes.productDetail__link} to={formatPattern("/:clubId/shop", { clubId: clubId })}>
        <Button label={translate("Retourner à la boutique")} fullWidth />
      </Link>
    </div>
  );
};

ProductDetail.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  clubId: PropTypes.string.isRequired,
  product: ImmutablePropTypes.map.isRequired,
  productBehavior: ImmutablePropTypes.map.isRequired,
  offer: ImmutablePropTypes.map.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  isPrepareCart: PropTypes.bool.isRequired
};

export default ProductDetail;



// WEBPACK FOOTER //
// ./src/app/components/ProductPage/ProductDetail/ProductDetail.js